export const map = () => {
  const buttons = document.querySelectorAll('.map .tab-btn');
  const items = document.querySelectorAll('.map__map-item');


  buttons.forEach((button, index) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      items.forEach(item => {
        item.classList.remove('active');
      });
      items[index].classList.add('active');

      buttons.forEach(item => {
        item.classList.remove('active');
      });
      button.classList.add('active');
    });
  });

  items.forEach((item) => {
    const texts = item.querySelectorAll('.map__text')
    const images = item.querySelectorAll('.map__images img')
    texts.forEach((text, index) => {
      text.addEventListener('click', (e) => {
        e.preventDefault();

        texts.forEach(item => {
          item.classList.remove('active');
        })
        text.classList.add('active');

        images.forEach(item => {
          item.classList.remove('active');
        })
        images[index].classList.add('active');
      })
    })
  })


  const scrollElements = (wrapper, slider, speed = 30, speedMobile = 70, hover = false, direction) => {
    const track = document.querySelector(wrapper);

    if (!track) {
      return;
    }

    const original = track.innerHTML;
    let singleSetWidth = 0;
    let offset = 0;
    let paused = false;
    let running = false;

    const waitImages = () => {
      const images = Array.from(track.querySelectorAll('img'));

      return Promise.all(images.map((image) => {
        if (image.complete) {
          return Promise.resolve();
        }
        return new Promise((resolve) => {
          image.addEventListener('load', resolve, {once: true});
          image.addEventListener('error', resolve, {once: true});
        });
      }));
    }

    const measureTrack = () => {
      singleSetWidth = track.scrollWidth / 3;

      if (singleSetWidth) {
        offset = offset % singleSetWidth;
      }
    }

    const moveTrack = (time, deltaTime) => {
      if (paused || !singleSetWidth) {
        return;
      }

      const currentSpeed = window.innerWidth <= 999 ? speedMobile : speed;
      const shift = (deltaTime / 1000) * currentSpeed;

      offset += direction === '-' ? -shift : shift;

      if (offset <= -singleSetWidth) {
        offset += singleSetWidth;
      }
      if (offset >= singleSetWidth) {
        offset -= singleSetWidth;
      }

      gsap.set(track, {x: offset});
    }

    const startTrack = () => {
      measureTrack();

      if (!singleSetWidth || running) {
        return;
      }

      running = true;
      gsap.ticker.add(moveTrack);
    }

    if (hover) {
      const ticker = document.querySelector(slider);
      ticker.addEventListener('mouseenter', () => paused = true);
      ticker.addEventListener('mouseleave', () => paused = false);
    }

    let resizeTimer = null;
    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth === lastWidth) {
        return;
      }

      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => waitImages().then(startTrack), 300);
    });

    track.innerHTML = original + original + original;
    waitImages().then(startTrack);
  }

  scrollElements('.map__trusted-logos .map__trusted-logos-wrapper', '.map__trusted-logos', 30, 70, true, '-')

}
